import { format } from 'date-fns';

const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const SECONDS_IN_HOUR = 3600;
const PERCENT = 100;

export const calculateBarOffsetPercentage = (event, ref) => {
    const clickX = event.clientX - ref.getBoundingClientRect().left;
    const percentage = (clickX / ref.offsetWidth) * PERCENT;

    return percentage;
};

export const formatDynamicDuration = durationInSeconds => {
    const hours = Math.floor(durationInSeconds / SECONDS_IN_HOUR);
    const minutes = Math.floor((durationInSeconds % SECONDS_IN_HOUR) / MINUTES_IN_HOUR);
    const seconds = durationInSeconds % SECONDS_IN_MINUTE;

    let formatString = '';

    if (hours > 0) {
        formatString = 'HH:mm:ss';
    } else {
        formatString = 'mm:ss';
    }

    const formattedTime = format(new Date(0, 0, 0, hours, minutes, seconds), formatString);

    return formattedTime;
};

export const calculateSegments = (sprite, duration) => {
    const segments = sprite.map(time => {
        const toPercent = (time / duration) * PERCENT;

        return toPercent;
    });

    // eslint-disable-next-line comma-dangle
    return segments.slice(1,);
};
